module.exports = __webpack_public_path__ + "static/pool-dddfe28e7d9c9064d71aae9f3a165d86.png";